// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAs7OmyPE5m4OQH7LrwA_nU99K9fKULuhY",
  authDomain: "master-collectors-forge.firebaseapp.com",
  projectId: "master-collectors-forge",
  storageBucket: "master-collectors-forge.firebasestorage.app",
  messagingSenderId: "959078784750",
  appId: "1:959078784750:web:a935c48e17009c51f41dff",
  measurementId: "G-KYQBJ7DPKZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
export default app;
